import { words, getInitialConfigureState, stateKeysToSetAddress } from './globalState';
// import { loadDeck, handleClickChallengeDuel } from './monadomCore';
import {
  getNote,
  getUserResource,
  getNotesAndUserResources,
  getComponents,
} from './note';
import {
  certificationWithKey,
  setSignatureByAddressMain,
  getAddressFromKeyNW,
} from './keysAndSigning';
import { getBalancesMonaparty, getAssetInfo } from './blockchain';
import {
  setAddressesInCookie,
} from './monacottoMisc';
import { syncHttpRequest2, devLog } from './utils';

// 「ログイン」ボタン押下 HANDLE CLICK LOGIN
async function handleClickLogin({
  dispatch,
  cookies,
  setCookie,
  navigate,
  popupLayer,
  keyPairs,
  keyPairsInPoolAll = {},
  sessionToOverride = {},
  activeAddressCandidate = null,
  login,
  walletType,
  session,
  marginOfSessionTime,
  assetInfos,
  monacards,
  network,
  usersGeneralIndex,
  noteToReload,
  notes,
  clientParameters,
  language,
}) {
  let request = {};
  let messages = {};
  let certifications = [];
  const popupLayerNext = (popupLayer !== undefined && popupLayer !== null) ? (popupLayer + 1) : 0;
  const now = Date.now();

  // state固定
  const stateFixed = {
    signatureVersion: clientParameters.signatureVersion.login,
    walletType: walletType,
    addressCheck: 'off',
  };

  devLog('session', JSON.stringify(session));
  devLog('session keys', JSON.stringify(Object.keys(session)));

  // セッション固定

  for (const address of Object.keys(session)) {
    stateFixed[address] = {
      sessionId: session[address].sessionId,
      expirationOfSession: session[address].expirationOfSession,
    };
  }

  // セッションのオーバーライド

  const addressesOverridden = Object.keys(session);

  for (const address of Object.keys(sessionToOverride)) {
    if (stateFixed[address] === undefined) {
      stateFixed[address] = {};
      addressesOverridden.push(address);
    }

    stateFixed[address].sessionId = sessionToOverride[address].sessionId;
    stateFixed[address].expirationOfSession = sessionToOverride[address].expirationOfSession;
  }

  // 有効なセッションに絞り込む。

  for (const address of addressesOverridden) {
    if (stateFixed[address].expirationOfSession >= now + (marginOfSessionTime ?? 60000)) {
      certifications.push({
        address: address,
        sessionId: stateFixed[address].sessionId,
      });
    }
  }

  // 署名

  if (keyPairs !== undefined && keyPairs !== null) {
    certificationWithKey({ dispatch, keyPairs, messageType: 'login', stateFixed, certifications, clientTime: now, extendedCertificationProperties: null, signingMode: 'allKeys', network, language });
  }
  else if (stateFixed.walletType === 'mpurse') {
    await setSignatureByAddressMain({ dispatch, stateFixed, certifications, clientTime: now, extendedCertificationProperties: null, messageType: 'login', language });
  }

  // 対象が無かった場合は戻る。ただし、KeyPairsが渡されていない場合は、鍵を要求する。

  if (
    certifications.length === 0
  ) {
    if (keyPairs === undefined || keyPairs === null) {
      if (stateFixed.walletType === 'nfc') {
        dispatch({ type: 'setNotification', key: 'notification', value: words.touchWithYourKeyCard[language] });
        return {
          status: 'rejected',
          message: 'nfcRequired',
        };
      }
      else if (stateFixed.walletType === 'qr') {
        dispatch({ type: 'setNotification', key: 'notification', value: words.scanYour2DBarcode[language] });
        return {
          status: 'rejected',
          message: 'bcRequired',
        };
      }
    }

    throw new Error(JSON.stringify({ error: 'noCertificationOrNoCertificationForAddressMain', notification: 'failedToLogin' }));
  }

  // GO!

  request.body = JSON.stringify({
    "body": {
      "certifications": certifications,
    }
  });

  request.url = 'https://' + process.env.REACT_APP_MONACOTTO_API_DOMAIN + '/login_and_reload';
  request.method = 'POST';

  messages = {
  };

  dispatch({ type: 'setState', key: 'accessing', value: true });

  const response = await syncHttpRequest2(request, 'user', undefined, undefined, messages, dispatch);

  dispatch({ type: 'setState', key: 'accessing', value: false });

  if ( response.status !== 'fulfilled' ) {
    throw new Error(JSON.stringify({ error: 'failedToLogin', notification: 'failedToLogin' }));
  }

  let loginAddressCount = {};
  if ( response.status === 'fulfilled' && response.body !== undefined && response.body !== null) {
    loginAddressCount.signature = Object.keys(response.body)
    .filter( address => response.body[address].certificatedBy === 'signature' )
    .length;

    loginAddressCount.sessionId = Object.keys(response.body)
    .filter( address => response.body[address].certificatedBy === 'sessionId' )
    .length;

    loginAddressCount.none = Object.keys(response.body)
    .filter( address => response.body[address].certificatedBy === 'none' )
    .length;

    loginAddressCount.success = loginAddressCount.signature + loginAddressCount.sessionId;
    loginAddressCount.failure = loginAddressCount.none;
    loginAddressCount.total = loginAddressCount.success + loginAddressCount.failure;
  }
  else {
    loginAddressCount = {
      signature: null,
      sessionId: null,
      none: null,
      success: null,
      failure: null,
      total: null,
    };
  }

  let certificationsToOverride = [];
  const body = response.body;
  const addresses = Object.keys(body);

  for (const address of Object.keys(response.body)) {
    // 署名した場合もろもろ更新
    if (response.body[address]['certificatedBy'] === 'signature') {

      // session更新
      dispatch({ type: 'setStateMultiLayers', keys: ['session', address],
        value: {'sessionId': response.body[address]['sessionId'], 'expirationOfSession': response.body[address]['expirationOfSession']} });

      // certification設定
      certificationsToOverride.push({ addressMain: address, sessionId: response.body[address].sessionId });
    }
    else if (response.body[address]['certificatedBy'] === 'none') {
      dispatch({ type: 'setStateMultiLayers', keys: ['session', address], value: { expirationOfSession: 0 } });
    }

    // MONA残高・カード関連情報取得
    if (response.body[address]['certificatedBy'] === 'signature' || response.body[address]['certificatedBy'] === 'sessionId') {
      // privateInformationをセット
      dispatch({ type: 'setStateMultiLayers', keys: ['privateInformation', address], value: response.body[address].basicInformation });

      // 保有アセット取得
      getBalancesMonaparty({ dispatch, address, clientParameters })
      .then( (result) => {
        let assets;

        if (result.status === 'fulfilled') {
          const balance = result.body;
          assets = Object.keys(balance);
        }
        else {
          throw new Error(result.error);
        }

        // もしかしたら、アセット情報取得は不要かもしれない。
        // アセット情報取得
        return getAssetInfo({ dispatch, assets, assetInfos, clientParameters });
      })
      .then( (result) => {
        let assetInfo;

        if (result.status === 'fulfilled') {
          // eslint-disable-next-line no-unused-vars
          assetInfo = result.body;
        }
        else {
          throw new Error(result.error);
        }

        // // モナカード情報取得
        // const assetCommons = Object.keys(assetInfo)
        // .filter( asset => {
        //   try {
        //     return JSON.parse(assetInfo[asset]?.description).monacard === undefined;
        //   }
        //   catch (error) {
        //     return true;
        //   }
        // })
        // .map( asset => assetInfo[asset].asset_longname === null ? asset : assetInfo[asset].asset_longname );

        // getMonacard({ dispatch, assets: assetCommons, monacards });
      })
      .catch( (error) => {
        // stateFixed.addressMainだったら、エラー＆再ログインしてください通知。
      });

      // ノート情報取得

      // -- 認証状態に変化したので、loadedをfalseにする。

      dispatch({ type: 'setStateMultiLayers', keys: ['editNote', 'loaded', 'popupDisplay', address], value: false });
      dispatch({ type: 'setStateMultiLayers', keys: ['editNote', 'loaded', 'components', address], value: {} });

      if (noteToReload?.screen === 'note' && address === noteToReload.addressMain) {
        getNote({
          dispatch,
          searchType: 'specificMyOwnNotes',
          addressesMain: [noteToReload.addressMain],
          noteNos: [noteToReload.noteNo],
          session,
          marginOfSessionTime,
          notes,
        })
        .then( result => {
          const notes = result[noteToReload.addressMain].notes;

          const components = notes.map( note => {
            return ['components', 'popupDisplay'].map( componentContainer => {
              return getComponents({
                note,
                componentContainer,
                session,
                marginOfSessionTime,
              });
            }).flat();
          }).flat();

          getUserResource({
            dispatch,
            userResources: components,
            session,
            marginOfSessionTime,
          });
        })
        .then( () => {
          // galleryに戻ったときに、note情報がクリアされてしまうから、特定ノートをlordedにしてはいけない。
          // const loadStatus = { [noteToReload.noteNo]: true };
          // dispatch({ type: 'setStateMultiLayers', keys: ['editNote', 'loaded', 'components', noteToReload.addressMain], value: loadStatus });
        })
        .catch( (error) => {
        })
      }

      if (noteToReload?.screen === 'gallery' && address === noteToReload.addressMain) {
        getNotesAndUserResources({
          dispatch,
          addressMain: noteToReload.addressMain,
          componentContainers: ['popupDisplay'],
          session,
          marginOfSessionTime,
          notes,
        })
        .then( () => {
          dispatch({ type: 'setStateMultiLayers', keys: ['editNote', 'loaded', noteToReload.addressMain], value: true });
        })
        .catch( (error) => {
        });
      }

      // // MONA残高取得

      // getAddressInfo({ clientParameters, address })
      // .then( (result) => {
      //   if (result.status === 'fulfilled') {
      //     const balance = result.body.balance;
      //     dispatch({ type: 'setStateMultiLayers', keys: ['balance', 'mona', address], value: balance });
      //   }
      //   else {
      //     devLog('failed to get address info.');
      //     // dispatch({ type: 'setNotification', key: 'notification', value: words.failedToSendMona[language] + '3.5' });
      //   }
      // });

      // // オウンドアセット情報取得
      // getOwnedAssets({ dispatch, address, clientParameters })
      // .then( (result) => {
      //   if (result.status === 'fulfilled') {
      //   }
      //   else {
      //     devLog('failed to get owned asset.');
      //     // dispatch({ type: 'setNotification', key: 'notification', value: words.failedToSendMona[language] + '3.5' });
      //   }
      // });

      // let activeCertification;

      // if (stateFixed.addressMain !== undefined && stateFixed.addressMain !== null && stateFixed.addressMain !== '') {
      //   if  (response.body[stateFixed.addressMain].certificatedBy === 'signature') {
      //     activeCertification = {
      //       address: stateFixed.addressMain,
      //       sessionId: response.body[stateFixed.addressMain].sessionId,
      //       expirationOfSession: response.body[stateFixed.addressMain].expirationOfSession,
      //     };
      //   }
      // }

      // const result = await handleClickGetPointSum(state, dispatch, activeCertification);
      // devLog('point sum', JSON.stringify(result.body));
    }
  }

  // // デッキ取得
  // loadDeck({
  //   session,
  //   dispatch,
  //   certificationsToOverride,
  //   marginOfSessionTime,
  // });

  let activeAddress;

  // ユーザー未登録、規約未同意の場合は、対象アドレスリストをポップアップで表示する。

  const addressesThatRequireUserRegistration = addresses.filter( address => body[address].applicationMessage === 'not accept TAC yet.');
  const addressesThatRequireAgreementOfTAC = addresses.filter( address => body[address].applicationMessage === 'you must accept the terms and conditions of the current version.');

  const basicInformationThatRequiresAgreementOfTAC = {};
  const applicationMessageParameterThatRequiresAgreementOfTAC = {};
  for (const address of addressesThatRequireAgreementOfTAC) {
    basicInformationThatRequiresAgreementOfTAC[address] = body[address].basicInformation;
    applicationMessageParameterThatRequiresAgreementOfTAC[address] = body[address].applicationMessageParameter;
  }

  if (addressesThatRequireUserRegistration.length > 0 || addressesThatRequireAgreementOfTAC.length > 0) {
    const popup = {
      type: 'registrationAndAgreementListPopup',
      body: {
        addressesThatRequireUserRegistration,
        addressesThatRequireAgreementOfTAC,
        basicInformationThatRequiresAgreementOfTAC,
        applicationMessageParameterThatRequiresAgreementOfTAC,
      },
    };

    dispatch({ type: 'setStateMultiLayers', keys: ['popup', popupLayerNext], value: popup });
  }

  // アクティブアドレスを設定

  if (activeAddressCandidate !== undefined && activeAddressCandidate !== null && activeAddressCandidate !== '') {
    if (
      (body?.[activeAddressCandidate]?.basicInformation !== undefined && body[activeAddressCandidate].basicInformation !== null) &&
      (body?.[activeAddressCandidate]?.certificatedBy === 'signature' || body?.[activeAddressCandidate]?.certificatedBy === 'sessionId')
    ) {
      activeAddress = activeAddressCandidate;
    }
    else {
      activeAddress = null;
    }
  }
  else if (keyPairs !== undefined && keyPairs !== null && keyPairs.length >= 1) {
    const activeKeyPair = keyPairs.find( keyPair => {
      const address = getAddressFromKeyNW({ dispatch, keyPair, language, network });
      return (
        (body?.[address]?.basicInformation !== undefined && body[address].basicInformation !== null) &&
        (body?.[address]?.certificatedBy === 'signature' || body?.[address]?.certificatedBy === 'sessionId')
      );
    });

    activeAddress = activeKeyPair ? getAddressFromKeyNW({ dispatch, keyPair: activeKeyPair, language, network }) : null;
  }
  else if (stateFixed.addressMpurse !== undefined && stateFixed.addressMpurse !== null && stateFixed.addressMpurse !== '') {
    if (
      (body?.[stateFixed.addressMpurse]?.basicInformation !== undefined && body[stateFixed.addressMpurse].basicInformation !== null) &&
      (body?.[stateFixed.addressMpurse]?.certificatedBy === 'signature' || body?.[stateFixed.addressMpurse]?.certificatedBy === 'sessionId')
    ) {
      activeAddress = stateFixed.addressMpurse;
    }
    else {
      activeAddress = null;
    }
  }
  else {
    activeAddress = null;
  }

  // 各種stateにアクティブアドレスをセット

  dispatch({ type: 'setStateMultiLayers', keys: ['active', 'addressMain'], value: activeAddress });

  const stateKeysToSetAddressForLogin = [
    ...stateKeysToSetAddress.filter( keys => !(keys[0] === 'active' && keys[1] === 'addressMain') ),
    ['getHistory', 'addressMain'],
    ['getPermissionHistory', 'addressMain'],
  ];

  for (const keys of stateKeysToSetAddressForLogin) {
    dispatch({ type: 'setStateMultiLayers', keys: keys, value: activeAddress ?? '' });
  }

  if  (activeAddress !== undefined && activeAddress !== null) {
    // 基本情報をconfigureにセット

    dispatch({ type: 'setState', key: 'configure', value: body[activeAddress].basicInformation });

    // cookie情報更新(アドレス情報)
    const userName = usersGeneralIndex?.[activeAddress]?.userName ?? activeAddress;
    const cookiesNew = [
          {
            action: 'login',
            addressType: 'addressMain',
            description: `${userName}`,
            time: now,
            address: activeAddress
          },
    ];

    setAddressesInCookie({ dispatch, cookies, setCookie, addressMain: activeAddress, cookiesNew, clientParameters });

    // ログインポップアップを消す
    if (popupLayer !== undefined && popupLayer !== null) {
      dispatch({ type: 'setStateMultiLayers', keys: ['popup', popupLayer], value: { type: null, body: null } });
    }
  }
  else {
    dispatch({ type: 'setState', key: 'configure', value: getInitialConfigureState() });
  }

  return { ...response, activeAddress, loginAddressCount };
}

export {
  handleClickLogin,
};